import { createAsyncThunk } from "@reduxjs/toolkit";

import { getUser } from "services/userServices";
import { discardSession } from "features/auth/authAction";
import type { User } from "types/User";
import { PRINCIPAL, TEACHER, PERMISSION_DENIED_ERROR } from "config/keywords";

const getUserProfile = createAsyncThunk<
  { user: User },
  void,
  { rejectValue: string }
>("user/getUserProfile", async (_: void, { dispatch, rejectWithValue }) => {
  let user: User;
  try {
    user = await getUser();
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
  if (user.role !== PRINCIPAL && user.role !== TEACHER) {
    // Done here rather than in each caller (login form, router loader), so no
    // caller leaves the refresh token behind.
    await dispatch(discardSession());
    return rejectWithValue(PERMISSION_DENIED_ERROR);
  }
  return { user };
});

export { getUserProfile };
